import axios from 'axios'

export default {
    sendContactMail(mail) {
        return axios.post(process.env.VUE_APP_BACKEND_BASE_URL + '/mail/contact', mail, { headers: { "Access-Control-Allow-Origin": "*", } }).then((response) => {
            return response
        })
    }
}
